import ReactDOM from "react-dom";
import ButtonV2 from "../../../../components/ui/button/v2";

interface ChangesModalProps {
    onAction: (mode: 'DISCARD' | 'CONTINUE') => void;
    disabled?: boolean;
}

const InterviewUnSavedChangesModal: React.FC<ChangesModalProps> = ({
    onAction,
    disabled=false
}) => {
    const modalContent = (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto relative z-[10000]">
                <div className="space-y-4 px-6 pt-6 pb-4">
                    <div className="flex justify-end items-center pb-0">
                        <button
                            onClick={onAction.bind(this, "CONTINUE")}
                            className="text-gray-500 hover:text-gray-700 focus:outline-none"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div className="flex justify-center flex-col gap-2 items-center relative top-[-20px]">
                        <div className="block text-lg font-semibold text-foreground">You have unsaved changes</div>
                        <p className="text-sm text-muted-color">Click {"‘Continue Editing’"} to ensure your changes are not lost</p>
                    </div>
                </div>
                <div className="px-6 pb-6 flex gap-4 w-full">
                    <ButtonV2 onClick={onAction.bind(this, "DISCARD")} className='w-full' variant="secondary"  disabled={disabled}>Don't Save</ButtonV2>
                    <ButtonV2 onClick={onAction.bind(this, "CONTINUE")} className='w-full' variant="primary"   disabled={disabled}>
                        Continue Editing
                    </ButtonV2>
                </div>
            </div>
        </div>
    );

    return ReactDOM.createPortal(modalContent, document.body);
};

export default InterviewUnSavedChangesModal;